import { ApiResponse } from "@/domain"
import { toast } from "@/hooks/use-toast"

export const onErrorGenericResponse = (response: ApiResponse<any>) => {
  console.log(response)
  toast({
    title: 'Error',
    description: response.message || response.error || 'Error inesperado',
    variant: 'destructive',
  })
}